import axios from 'src/utils/axios';
import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  alergenos: [],
  error: false
};

const slice = createSlice({
  name: 'alergenos',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setAlergenos(state, action) {
      state.alergenos = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions — expuestas para que otros thunks (ej. loadTpvBootstrap)
// puedan hidratar el slice sin re-lanzar el fetch de /alergenos.
export const { setAlergenos } = slice.actions;

export function getAlergenos() {
  return async (dispatch) => {
    try {
      const response = await axios.get('alergenos');
      dispatch(slice.actions.setAlergenos(response.data.alergenos));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
